// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-BaqUtv{justify-content:center;align-items:center;width:100%;height:24px;overflow:hidden}.container-BaqUtv .bar-bTOWf8{background-color:#aaa;border-radius:8px;width:4px;min-height:6px;max-height:24px;transition:height .1s ease-in-out}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container-BaqUtv`,
	"bar": `bar-bTOWf8`
};
export default ___CSS_LOADER_EXPORT___;
